import { Grid } from "@mui/material";
import React from "react";
import { WSTabs } from "../../Components/Tabs/WSTabs";
import { FormProvider, useForm } from "react-hook-form";
import { FilterCriteria } from "./FilterCriteria";
import { OtherSettings } from "./OtherSettings";

export const SalesReport:React.FC<any>=React.memo((props)=>{
    const methods = useForm();
  const { handleSubmit, control, register } = methods;
    const tabs = [
        { label: "Filter Criteria", content: <FilterCriteria/>},
        { label: "Other Settings", content:<OtherSettings/>},
       
      ];
      const onSubmit = async (data: any) => {
        console.log("onsubmit===>", data); // You can perform any action with the submitted data here
      };
    return(
        <Grid container >
              <FormProvider {...methods}>
              <form onSubmit={handleSubmit(onSubmit)}  style={{ width: '100%' }}>
            <Grid item xs={12}>
            <WSTabs id={"tabs"} control={control} name={"tabs"} tabs={tabs} />
            </Grid>
            </form>
            </FormProvider>
        </Grid>
    )
})